import styled from "@emotion/styled";

export const Root = styled.div(() => ({
    height: 2,
}));

export const LoadingBar = styled.div<{ percentage: number; loaderSpeed: undefined | string }>(props => ({
    height: 2,
    width: `${props.percentage}%`,
    transition: props.loaderSpeed && `width ${props.loaderSpeed} 0s linear`,
    backgroundColor: props.theme.candy.semanticColors.action.alternativeColor,
}));
